var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 33498"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 764",
    opacity: 0.1,
    cx: 32,
    cy: 32,
    r: 32,
    fill: "#4ECA4D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.9999 57.6004C17.8559 57.6004 6.3999 46.1444 6.3999 32.0004C6.3999 17.8564 17.8559 6.40039 31.9999 6.40039C46.1439 6.40039 57.5999 17.8564 57.5999 32.0004C57.5999 46.1444 46.1439 57.6004 31.9999 57.6004ZM43.5839 23.6164C42.8159 22.8484 41.5999 22.8484 40.8319 23.6164L28.6079 36.1604L23.1679 30.5284C22.3999 29.7604 21.1839 29.7604 20.4159 30.5284C19.6479 31.2964 19.6479 32.5764 20.4159 33.3444L27.2639 40.3844C28.0319 41.1524 29.2479 41.1524 30.0159 40.3844L43.6479 26.4324C44.3519 25.6644 44.3519 24.3844 43.5839 23.6164Z",
    fill: "#01AC47"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.7d8eff5c31ffa11d93b23ec7dbdc55bb.svg";
export { ForwardRef as ReactComponent };